module.exports = [
  {name: 'USD', value: 'USD'},
  {name: 'EUR', value: 'EUR'},
  {name: 'GBP', value: 'GBP'},
  {name: 'SEK', value: 'SEK'},
  {name: 'Danish krone', other: true, value: 'DKK'},
  {name: 'Norwegian krone', other: true, value: 'NOK'},
  {name: 'Japanese yen', other: true, value: 'JPY'},
  {name: 'Bulgarian lev', other: true, value: 'BGN'},
  {name: 'Czech koruna', other: true, value: 'CZK'},
  {name: 'Hungarian forint', other: true, value: 'HUF'},
  {name: 'Polish zloty', other: true, value: 'PLN'},
  {name: 'Romanian leu', other: true, value: 'RON'},
  {name: 'Swiss franc', other: true, value: 'CHF'},
  {name: 'Croatian kuna', other: true, value: 'HRK'},
  {name: 'Russian rouble', other: true, value: 'RUB'},
  {name: 'Turkish lira', other: true, value: 'TRY'},
  {name: 'Australian dollar', other: true, value: 'AUD'},
  {name: 'Brazilian real', other: true, value: 'BRL'},
  {name: 'Canadian dollar', other: true, value: 'CAD'},
  {name: 'Chinese yuan renminbi', other: true, value: 'CNY'},
  {name: 'Hong Kong dollar', other: true, value: 'HKD'},
  {name: 'Indonesian rupiah', other: true, value: 'IDR'},
  {name: 'Israeli shekel', other: true, value: 'ILS'},
  {name: 'Indian rupee', other: true, value: 'INR'},
  {name: 'South Korean won', other: true, value: 'KRW'},
  {name: 'Mexican peso', other: true, value: 'MXN'},
  {name: 'Malaysian ringgit', other: true, value: 'MYR'},
  {name: 'New Zealand dollar', other: true, value: 'NZD'},
  {name: 'Philippine peso', other: true, value: 'PHP'},
  {name: 'Singapore dollar', other: true, value: 'SGD'},
  {name: 'Thai baht', other: true, value: 'THB'},
  {name: 'South African rand', other: true, value: 'ZAR'},
  {name: 'Icelandic krona', other: true, value: 'ISK'}
]



// WEBPACK FOOTER //
// ./client/utils/currencies.js